import { getCheckoutSessionFlags, isUserActionCommit } from '../../globals';
import {
  getVariantFromTreatmentName,
  includesTreatment,
} from '../../features/utils';
import { PASSWORDLESS_SIGNUP_CONTENT_KEYS } from './constants';
import { getPOMAEligibility } from '../../features/featureEligibility';

// Elmo link:
export const passwordlessContentKey = (): string => {
  const isWPS = getCheckoutSessionFlags()?.isWPS;
  const feature = 'FEATURE_MERCHANT_BASED_FLOW_TYPE';

  const isTreatment = includesTreatment({
    feature,
    treatment: 'EXISTING_MEMBER_ACCOUNT_BASED_CTA',
  });

  const contentKeys = isUserActionCommit()
    ? PASSWORDLESS_SIGNUP_CONTENT_KEYS.COMMIT
    : PASSWORDLESS_SIGNUP_CONTENT_KEYS.DEFAULT;

  const defaultKey = contentKeys.DEFAULT;

  if (getPOMAEligibility() && isWPS) {
    return contentKeys.DEFAULT;
  }

  if (isTreatment) {
    const variant = getVariantFromTreatmentName({
      defaultVariant: 'DEFAULT',
      feature,
    }) as keyof typeof contentKeys;

    return contentKeys[variant] || defaultKey;
  }

  return defaultKey;
};
